import { SerializedFile } from '@mailings/types/mailings.types';
import CloseM from '@semcore/icon/Close/m';
import DocumentPdfM from '@semcore/icon/DocumentPdf/m';
import Button from '@semcore/ui/button';
import Tag from '@semcore/ui/tag';
import { useTranslation } from 'react-i18next';

interface ObjectivesFormFilePresenterProps {
  file: SerializedFile | File;
  onRemove: () => void;
}

export const ObjectivesFormFilePresenter = ({
  file,
  onRemove,
}: ObjectivesFormFilePresenterProps) => {
  const { t } = useTranslation(['mailings']);

  const fileName = file instanceof File ? file.name : file.originalFilename;

  return (
    <Tag
      className="w-80 justify-between gap-2"
      color="gray-500"
      size="l"
      theme="primary">
      <Tag.Addon className="gap-1 pl-0.5">
        <DocumentPdfM />
        <Tag.Text
          ellipsis
          className="w-64">
          {fileName}
        </Tag.Text>
      </Tag.Addon>
      <Button
        aria-label={t(
          'mailings:personalizedMailingCreatorWizard.objectivesForm.fileUpload.removeFileAriaLabel',
        )}
        data-test="remove-file-button"
        theme="muted"
        use="primary"
        onClick={onRemove}>
        <Button.Addon>
          <CloseM />
        </Button.Addon>
      </Button>
    </Tag>
  );
};
